import {
  getSPDataWithParams,
  getSPDataWithoutParams,
  postSPDataWithoutParams,
} from './services'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'

function extractCommonArray(response, key) {
  if (response?.status !== 200 || !isCommonResponseSuccessfulV2(response)) {
    return []
  }
  const data = getDataMapFromCommonResponse(response)
  if (Array.isArray(data)) return data
  if (Array.isArray(data?.[key])) return data[key]
  const arrayKey = data && Object.keys(data).find((itemKey) => Array.isArray(data[itemKey]))
  return arrayKey ? data[arrayKey] : []
}

function extractPageContent(response) {
  if (Array.isArray(response?.data?.content)) return response.data.content
  if (Array.isArray(response?.data)) return response.data
  return []
}

export async function fetchScreenerProfileCandidates() {
  const response = await getSPDataWithParams('/api/secure/cc/support/screeners/all/list', {
    includeDisabled: true,
  })
  return extractCommonArray(response, 'mentor')
}

export async function fetchScreenerProfiles() {
  const response = await getSPDataWithParams('/api/secure/cc/support/screeners/profiles/page', {
    includeDisabled: true,
    includeDeleted: false,
    page: 0,
    size: 500,
  })
  return extractPageContent(response)
}

export async function fetchScreenerProfileConfigGaps() {
  const response = await getSPDataWithParams(
    '/api/secure/cc/support/screeners/profiles/role-service-config-gap/list',
    {},
  )
  return extractCommonArray(response, 'screenerRoleServiceConfigGap')
}

export async function fetchScreenerTargetSpecialties() {
  const response = await getSPDataWithParams('/api/secure/cc/support/target-specialties/page', {
    includeDisabled: true,
    page: 0,
    size: 200,
  })
  return extractPageContent(response)
}

export async function fetchScreenerDomains() {
  const response = await getSPDataWithoutParams('/api/secure/cc/support/domain/all/list')
  return Array.isArray(response?.data) ? response.data : []
}

export async function saveScreenerProfile(payload) {
  return postSPDataWithoutParams('/api/secure/cc/support/screeners/profiles/save', payload)
}
